export const SET_SELECTED_BANK = "SET_SELECTED_BANK";
